<form [formGroup]="form">
    <label *ngIf="label_block" class="m-0 html-label" [ngClass]="{'req':required}"
        [innerHtml]="label | HTMLFormatter"></label>

    <mat-form-field [title]="label ? (label | HTMLFormatter : 1) : ''" floatLabel="always" appearance="standard"
        [ngClass]="label_class && label_class!='' ?label_class:''">
        <mat-label *ngIf="!label_block&&required&&label" class="req">
            <span [innerHtml]="label | HTMLFormatter"></span>
        </mat-label>
        <mat-label *ngIf="!label_block&&!required&&label&&label!=''">

            <span [innerHtml]="label | HTMLFormatter"></span>

        </mat-label>
        <mat-label *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
            <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
                style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
            <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
                style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
            <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
                class="fa fa-commenting-o pr-3"></i>
            <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''"
                style="pointer-events:visible !important;" class="fa fa-info"></i>
        </mat-label>

        <span matPrefix class="prefix" *ngIf="prefix_label">{{prefix_label}}&nbsp;</span>
        <span matSuffix class="suffix" *ngIf="suffix_label">&nbsp;{{suffix_label}}</span>
        <input (keydown)="regexCheck($event)" matInput [placeholder]="placeholder" [value]="value" type="number"
            [id]="id" [style]="style ? style : ''" [formControlName]="controlName" [maxlength]=" getNumber(maxLength) "
            [minLength]="minLength" [max]="maxValue" [min]="minValue" [readonly]="disabled ? true : false"
            [name]="random_id">
        <mat-error *ngIf="form.get([controlName]).hasError('required');else maxlength">
            Field is mandatory
            <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </mat-error>
        <ng-template #maxlength>
            <mat-error *ngIf="form.get([controlName]).hasError('maxlength');else minlength">
                Maximum length ({{maxLength}}) has exceeded
            </mat-error>
        </ng-template>
        <ng-template #minlength>
            <mat-error *ngIf="form.get([controlName]).hasError('minlength');else maxvalue">
                Minimum length must be {{minLength}} digits
            </mat-error>
        </ng-template>
        <ng-template #maxvalue>
            <mat-error *ngIf="form.get([controlName]).hasError('max');else minvalue">
                Value must be lesser than {{maxValue}}
            </mat-error>
        </ng-template>
        <ng-template #minvalue>
            <mat-error *ngIf="form.get([controlName]).hasError('min')">
                Value must be greater than {{minValue}}
            </mat-error>
        </ng-template>
    </mat-form-field>
</form>